import React, { useCallback } from 'react';

import { Chip } from '@occc-app/design-system';

export interface IChipGroupItemProps {
  value: string;
  onClick: (value: string) => void;
  label: string;
  selected: boolean;
  disabled?: boolean;
}

const ChipGroupItem: React.FC<IChipGroupItemProps> = ({
  value,
  onClick,
  label,
  selected,
  disabled,
}) => {
  const handleClick = useCallback(() => {
    onClick(value);
  }, [value, onClick]);

  return (
    <Chip
      sx={{
        mb: 1,
        mr: 1,
      }}
      onClick={handleClick}
      color={selected ? 'primary' : 'default'}
      variant={selected ? 'filled' : 'outlined'}
      label={label}
      disabled={disabled}
    />
  );
};

export default ChipGroupItem;
